var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 59,
    viewBox: "0 0 423 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17651 6.77295H58.6893V23.0232M58.6893 23.0232H20.8524M58.6893 23.0232V51.4009L55.4149 54.6752H2.41906V34.1802M2.41906 34.1802H39.2858M2.41906 34.1802V7.0153",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.055 4.29593H61.9945L61.6697 3.48389V23.299H78.8861V54.9707H100.001V24.2735H117.055V4.29593Z",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.086 7.40869H120.824L121.978 20.7622H128.243V35.1054H119.176V54.8891H135.167L144.4 45.6567H159.732V54.3945H180.257V14.58L173.086 7.40869Z",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.647 50.4191L203.414 55.652C197.06 55.652 184.464 55.652 184.912 55.652C185.361 55.652 185.099 42.3204 184.912 35.6546H193.135V30.9831H185.099V17.8997L195.565 18.4603V6.68604H213.133V17.8996H226.402V7.99456H249.016V26.31L241.914 32.1036L226.028 35.0939C232.196 35.0939 244.755 35.0939 245.652 35.0939C246.773 35.0939 245.652 54.5307 245.652 55.0914C245.652 55.5399 229.33 55.2783 221.169 55.0914C221.169 55.0914 212.821 51.9765 208.647 50.4191ZM208.647 50.4191V29.4871",
    stroke: "white",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M292.355 6.76318H252.855L251.958 20.0495H262.91V34.7723H249.264V55.9587H292.715C293.289 55.9587 292.954 42.0738 292.715 35.1314H279.249V20.4086H292.355V6.76318Z",
    stroke: "white",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.1 20.5862V6.22312L308.335 8.19846V2.45299L326.469 2.45264L326.289 8.01856L349.81 6.58219L356.094 14.1231L355.196 56.6755L335.626 56.855L336.164 19.689L323.237 20.2277L321.262 48.2368L312.464 55.5982L294.869 55.7778V33.6936H307.616V20.5862H298.1Z",
    stroke: "white",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M418.775 6.60253C419.356 11.5127 420.169 21.333 418.775 21.333C417.381 21.333 401.089 21.333 393.117 21.333C392.747 25.7674 392.23 34.6364 393.117 34.6364C394.004 34.6364 398.238 34.6364 400.244 34.6364H377.437L390.345 21.7281H420.359V56.335H358.114V29.8849L384.327 3.67236L418.775 6.60253Z",
    stroke: "white",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.771 31.9456L148.889 20.3833L161.559 20.3837L161.243 31.9457L144.771 31.9456Z",
    stroke: "white",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.434177ed037e43c7c886372ba35f3191.svg";
export { ForwardRef as ReactComponent };